(() => {
  const media = window.matchMedia('(max-width: 749px)');
  function prepareFooter() {
    document.querySelectorAll('footer .footer-content').forEach(footer => {
      Array.from(footer.children).forEach((group, index) => {
        if (index === 0 || group.matches('details')) return;
        const heading = group.querySelector('h3,h4');
        if (!heading) return;
        const details = document.createElement('details');
        details.className = 'theralica-footer-accordion';
        details.open = !media.matches;
        const summary = document.createElement('summary');
        summary.textContent = heading.textContent;
        heading.classList.add('theralica-footer-original-heading');
        group.before(details);
        details.append(summary, group);
      });
    });
  }
  function updateFooter() {
    document.querySelectorAll('.theralica-footer-accordion').forEach(el => { el.open = !media.matches; });
  }
  prepareFooter();
  media.addEventListener('change', updateFooter);
  document.addEventListener('shopify:section:load', prepareFooter);
})();
(() => {
  function applyCureRecommendation() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    const recommended = document.querySelector('variant-picker[data-template-product-match="true"] input[data-cure-recommended="true"]');
    if (recommended && !recommended.checked && recommended.dataset.optionAvailable === 'true') recommended.click();
  }
  function compactQuality() {
    const mobile = window.matchMedia('(max-width:749px)').matches;
    document.querySelectorAll('.theralica-quality-details').forEach(el => { el.open = !mobile; });
  }
  applyCureRecommendation();
  compactQuality();
  window.matchMedia('(max-width:749px)').addEventListener('change',compactQuality);
})();
document.querySelectorAll('product-card[data-recommended-cure-url]').forEach(card => {
  const target = card.getAttribute('data-recommended-cure-url');
  const targetPath = new URL(target,window.location.origin).pathname;
  card.querySelectorAll('a[href]').forEach(link => {if(new URL(link.href).pathname === targetPath) link.href = target;});
});
